import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaInputTime'

type IcaInputTimeProps = React.JSX.IntrinsicElements['tgdb-ica-input-time']

export const IcaInputTime = wrapWc<IcaInputTimeProps>('tgdb-ica-input-time', ['change'])